export default __webpack_public_path__ + "005a577256b696d5090376d8d07819f7.svg";